const initalState = {
    mjglobal: {
        // null = no category picked yet, so the home page shows the plain
        // recent/popular feed. It used to default to 1 (Carros), which
        // silently filtered the home page to cars-only on every first visit.
        selectedCategory: null
    },
};
export const generalReducer = (state = initalState.mjglobal, action) => {
    // console.log(state, action);
    switch (action.type) {
        case 'selectedCategory':
            return {
                ...state,
                selectedCategory: action.selectedCategory

            };
        default:
            return state;
    }
}
